/* global Swiper */

document.querySelectorAll( '.b-timeline' ).forEach( ( block ) => {

	const slider = block.querySelector( '.swiper' );
	const events = block.querySelectorAll( '.b-timeline__event' );

	if ( slider ) {

		new Swiper( slider, {
			enabled: false,
			scrollbar: {
				el: '.swiper-scrollbar',
				draggable: true,
			},
			breakpoints: {
				576: {
					enabled: true,
					slidesPerView: 'auto',
				}
			}
		} );

		events.forEach( event => {

			const desc = event.querySelector( '.b-timeline__event-desc-wrap' );
			if ( !desc ) {

				return;

			}

			desc.dataset.height = desc.scrollHeight;
			desc.style.maxHeight = '0px';

			event.addEventListener( 'mouseenter', () => {

				desc.style.maxHeight = `${desc.dataset.height  }px`;

			} );

			event.addEventListener( 'mouseleave', () => {

				desc.style.maxHeight = '0px';

			} );

		} );

	}

} );
